// Vuex user module mutations types
export const FILL_DETAILS = 'FILL_DETAILS';
export const EXPORT_FILE = 'EXPORT_FILE';
